import React, { ElementType } from 'react';
import { FieldRenderProps } from 'react-final-form';

export interface FinalFormWrapperInterface extends FieldRenderProps<string> {
  component: ElementType;
}

const FinalFormInputWrapper: React.FC<FinalFormWrapperInterface> = (props) => {
  const {
    component: Component,
    render,
    children,
    input,
    meta: { submitError, dirtySinceLastSubmit, touched, invalid, submitting, error },
    ...otherProps
  } = props;

  const hasError =
    Boolean((submitError && !dirtySinceLastSubmit) || invalid) && touched && !submitting;

  return <Component hasError={hasError} error={error} {...input} {...otherProps} />;
};

export default FinalFormInputWrapper;
